import fontRobotoLatin100 from '../fonts/roboto/latin-100.woff2';
import fontRobotoLatin100Italic from '../fonts/roboto/latin-100italic.woff2';
import fontRobotoLatin300 from '../fonts/roboto/latin-300.woff2';
import fontRobotoLatin300Italic from '../fonts/roboto/latin-300italic.woff2';
import fontRobotoLatin400 from '../fonts/roboto/latin-400.woff2';
import fontRobotoLatin400Italic from '../fonts/roboto/latin-400italic.woff2';
import fontRobotoLatin500 from '../fonts/roboto/latin-500.woff2';
import fontRobotoLatin500Italic from '../fonts/roboto/latin-500italic.woff2';
import fontRobotoLatin700 from '../fonts/roboto/latin-700.woff2';
import fontRobotoLatin700Italic from '../fonts/roboto/latin-700italic.woff2';
import fontRobotoLatin900 from '../fonts/roboto/latin-900.woff2';
import fontRobotoLatin900Italic from '../fonts/roboto/latin-900italic.woff2';

export const fontFaces = {
  fontRobotoLatin100,
  fontRobotoLatin100Italic,
  fontRobotoLatin300,
  fontRobotoLatin300Italic,
  fontRobotoLatin400,
  fontRobotoLatin400Italic,
  fontRobotoLatin500,
  fontRobotoLatin500Italic,
  fontRobotoLatin700,
  fontRobotoLatin700Italic,
  fontRobotoLatin900,
  fontRobotoLatin900Italic,
};
